// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__9ctbu","bigColWidth":"Table_bigColWidth__2gp22","biggerColWidth":"Table_biggerColWidth__1SYZD","row":"Table_row__2mK4J","col":"Table_col__37uiR"};